import React from "react";
import "./Text.scss";

function Text({ children = "Default Text", align = "center" }) {
  return (
    <div className="text">
      <div style={{ textAlign: align }}>{children}</div>
    </div>
  );
}

export default Text;
